
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users, PlusCircle } from "lucide-react";

type NoAgentSelectedProps = {
  onCreateAgent: () => void;
};

export const NoAgentSelected = ({ onCreateAgent }: NoAgentSelectedProps) => {
  return (
    <Card className="md:col-span-3 flex items-center justify-center p-8">
      <div className="text-center">
        <Users className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
        <h3 className="text-lg font-medium mb-2">No Agent Selected</h3>
        <p className="text-muted-foreground mb-4">Create a new agent or select an existing one to configure</p>
        <Button onClick={onCreateAgent} className="flex items-center gap-2">
          <PlusCircle className="h-4 w-4" />
          Create New Agent
        </Button>
      </div>
    </Card>
  );
};
